import React from "react";
import Countdown from "react-countdown";

const Countdowntimer = () => {
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span>Countdown Finished!</span>;
    } else {
      return (
        <div className="d-flex align-items-center gap-1 gap-md-4 count">
          <div style={{ display: "inline-block", margin: "10px" }}>
            <div className="ring">

              <div className="title-countdown" >{days}</div>
            </div>
            <p className="fs-5 text-center mt-3" >Days</p>
          </div>
          <div style={{ display: "inline-block", margin: "10px" }}>
            <div className="ring">

              <div className="title-countdown">{hours}</div>
            </div>
            <p className="fs-5 text-center mt-3" >Hours</p>
          </div>
          <div style={{ display: "inline-block", margin: "10px" }}>
            <div className="ring">

              <div className="title-countdown" >{minutes}</div>
            </div>
            <p className="fs-5 text-center mt-3">Minutes</p>
          </div>
          <div style={{ display: "inline-block", margin: "10px" }}>
            <div className="ring">

              <div className="title-countdown">{seconds}</div>
            </div>
            <p className="fs-5 text-center mt-3" >Seconds</p>
          </div>
        </div>
      );
    }
  };

  return (
    <Countdown date={'2025-01-31T23:00:00Z'} renderer={renderer} />
  );
};

export default Countdowntimer;
